<template>
  <div class="wrapper">
    <div class="box">
      <img class="imgs" :src="img" alt="" v-for="(img,index) in imgArr" :key="index" @click="showImage(imgArr,index)">
    </div>
  </div>
</template>
<script>
  import weChatShareApi from "../../assets/js/weChatShare";
  import { handleText } from "../../assets/js/tool";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        imgArr: [],
      }
    },
    watch: {},
    computed: {
    },
    methods: {
      showImage(imgArr, index) {
        wx.previewImage({
          current: imgArr[index],
          urls: imgArr
        })
      },
      initPage() {
        let that = this
        this.$commonPost({
          jydm: "flow_10060",
          flow_10060: {
          }
        }).then(response => {
          let arr = response.config
          let configObj = {}
          arr.forEach((item) => {
            configObj[item.nbr] = item.value
          });
          let imgArr = [];
          if (configObj['10041']) {
            imgArr = configObj['10041'].split(',')
          }
          this.imgArr = imgArr
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
    },
    created() {
    },
    mounted() {
      document.title = '平台资质';
      this.initPage();
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl,
      };
      this.weChatShare(option);
    },
  };
</script>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    box-sizing: border-box;
  }

  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .imgs {
    width: 7.1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/credential.vue